import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=2b57f6a2&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=ts&"
export * from "./dashboard.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=2b57f6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57f6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b57f6a2', component.options)
    } else {
      api.reload('2b57f6a2', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=2b57f6a2&scoped=true&", function () {
      api.rerender('2b57f6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Peajes/Dashboard/dashboard.vue"
export default component.exports